import { FC } from 'react';

import useToggle from '@hooks/useToggle';

import CannedResponsesButton from './CannedResponsesButton/CannedResponsesButton';
import CannedResponsesModal from './CannedResponsesModal/CannedResponsesModal';
import { ICannedResponsesProps } from './CannedResponses.interface';

const CannedResponses: FC<ICannedResponsesProps> = ({ isMedication = false, onApply }) => {
  const [isOpen, handleOpen, handleClose] = useToggle();

  return (
    <>
      <CannedResponsesButton onClick={handleOpen} />
      <CannedResponsesModal
        isMedication={isMedication}
        open={isOpen}
        onClose={handleClose}
        onApply={onApply}
      />
    </>
  );
};

export default CannedResponses;
